<template>
    <div id="core_waybill" v-if="is_initialized">

        <div v-if="settings.is_package_mode || settings.is_unpackage_mode">
            <carousel
                v-if="is_mobile_width"
                :perPage="1"
                :speed="390"
                :minSwipeDistance="120"
                :paginationEnabled="false"
                >
                <slide>
                    <Package
                        :is_inverted="is_inverted">
                    </package>
                    <NavigationRight
                        :top="'18px'">
                    </NavigationRight>
                </slide>
                <slide>
                    <NavigationLeft
                        :top="'18px'">
                    </NavigationLeft>
                    <General
                        :is_inverted="is_inverted">
                    </General>

                </slide>
            </carousel>
            <div v-else>
                <div class="ui top tabular menu">
                    <div v-for="top_menu in top_menus"
                        class="item pointer"
                        :style="{color: theme.color.font}"
                        :class="{
                            'active': current_setting_component == top_menu.component_name
                        }"
                        @click="current_setting_component = top_menu.component_name">
                        {{ top_menu.title }}
                    </div>
                </div>

                <component
                    :is="current_setting_component"
                    :is_inverted="is_inverted">
                </component>
            </div>
        </div>
        <div v-else>
            <General
                :is_inverted="is_inverted">
            </General>
        </div>

    </div>
</template>

<script>
import Package from './core_waybill/package.vue'
import General from './core_waybill/general.vue'

import NavigationLeft from './navigation/left.vue'
import NavigationRight from './navigation/right.vue'

import { Carousel, Slide } from 'vue-carousel'

export default {
    components: {
        Package,
        General,

        NavigationLeft,
        NavigationRight,

        Carousel,
        Slide,
    },
    props: {
        is_modal_opened: {
            default: false,
            type: Boolean
        },
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            is_mobile_width: false,
            current_setting_component: 'Package',
            top_menus: [
                {
                    // "title": "包裝",
                    "title": this.$t('ui.scanner.menus.package'),
                    "component_name": "Package",
                },{
                    // "title": "運單",
                    "title": this.$t('ui.scanner.menus.core_waybill'),
                    "component_name": "General",
                // },{
                //     "title": "條碼狀態",
                //     "component_name": "ScanActionPrototypes",
                }
            ],
            update_core_waybills_eventbus_name: "update_core_waybills_in_scanner",
        }
    },
    mounted() {
        $(window).resize(() => {
            this.is_mobile_width = (this.style.width <= 767)
                ? true
                : false
        })
        this.init()
    },
    watch: {
        is_modal_opened(value) {
            if (value) {
                this.$forceUpdate()
            }
        },
    },
    computed: {
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        style() {
            return this.$store.state.style
        },
        theme() {
            return this.current_store.config.theme
        },
        settings() {
            return this.current_store.settings
        },
        current_core_waybill: {
            cache: false,
            get() {
                return this.current_store.current_core_waybill
            }
        },
        core_waybills() {
            return this.current_store.core_waybills
        },
    },
    methods: {
        async init() {
            this.is_initialized = false
            await this.set_is_mobile_width()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        set_is_mobile_width() {
            // check_is_mobile_width
            this.is_mobile_width = (this.style.width <= 767)
                ? true
                : false

            return ""
        },
    },

}
</script>

<style lang="scss" scoped>
    #core_waybill {
        .ui.top.menu .item {
            color: white;
        }
        .ui.top.menu .item.active {
            border-color: white;
            background: inherit;
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;
        }
    }
    .VueCarousel-slide {
        position: relative;
    }
    .VueCarousel-inner {
        flex-basis: 100%;
        visibility: visible;
    }

</style>
